export default __webpack_public_path__ + "static/media/docs.a9e41e46.svg";